<template>
  <div class="hello">
  开发中，即将发布……
  </div>
</template>

<script type="text/babel">
import sessionstorage from 'utils/sessionstorage'
import UserModel from 'models/user'

export default {
  name: 'home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      console.log('init data')
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        UserModel.find().then(res => {
          console.log(res)
        }).catch(err => { this.$message({ message: err.message, type: 'error' }) })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/HelloWorld.vue